import { writable, get } from "svelte/store";
import { derived } from "svelte/store";

const storageKey = "___order_kher___";

const emptyData = {
    customer_type: 'PERSONAL',
    name_and_surname: null,
    email: null,
    phone: null,
    address_street: null,
    address_city: null,
    address_zip: null,
    address_country: 'CZ',
    order_description: null,
    company_name: null,
    company_id: null,
    delivery_address_street: null,
    delivery_address_city: null,
    delivery_address_zip: null,
    delivery_address_country: null,
    delivery_payment_methods: [],
    terms_and_conditions_consent: false,
    sending_newsletters_consent: false,
    payment_title: null,
    payment_method_type: null,
    price_payment: null,

    // doprava
    delivery_id: null,
    delivery_type: null,
    delivery_title: null,
    delivery_data: {},
    delivery_is_personal_pickup: false,
    price_delivery: null,

};

const loadFromStorage = () => {
    let json = localStorage.getItem(storageKey);
    let data = json ? JSON.parse(json) : emptyData;
    return data;
};

const saveToStorage = (data) => {
    localStorage.setItem(storageKey, JSON.stringify(data));
};

const getDeliveryCountry = (data) => {
    if (data.customer_type == 'COMPANY' && data.delivery_address_country) {
        return data.delivery_address_country;
    }
    return data.address_country;
};

const clearDeliveryAndPayment = (data) => ({
    ...data,
    delivery_id: null,
    delivery_type: null,
    delivery_title: null,
    delivery_data: {},
    delivery_is_personal_pickup: false,
    delivery_payment_methods: [],
    price_delivery: null,
    payment_title: null,
    payment_method_type: null,
    price_payment: null,
});

/* store - BEGIN */
const createStore = () => {
    const store = writable(loadFromStorage());

    // "VEREJNE" metody - BEGIN
    const setProp = (name, value) => {
        const current = get(store);
        let next = {
            ...current,
            [name]: value
        };

        if (getDeliveryCountry(current) != getDeliveryCountry(next)) {
            next = clearDeliveryAndPayment(next);
        }

        store.set(next);
        persist();
        return validateProp(name, value);
    };

    const setDelivery = (delivery_id, delivery_type, delivery_title = null, price_delivery = null, delivery_data = {}, delivery_is_personal_pickup = false, delivery_payment_methods = []) => {
        store.update(current => ({
            ...current,
            delivery_id,
            delivery_type,
            delivery_title,
            price_delivery,
            delivery_data,
            delivery_is_personal_pickup,
            delivery_payment_methods,
            ...(current.delivery_id != delivery_id ? {
                payment_title: null,
                payment_method_type: null,
                price_payment: null,
            } : {}),
        }));
        persist();
    };

    const validateProp = (name, value) => {
        const current = get(store);

        // povinne polozky
        const required = [
            'customer_type', 'name_and_surname', 'email', 'phone',
            'address_street', 'address_city', 'address_zip', 'address_country',
            'terms_and_conditions_consent', 'delivery_id', 'delivery_type', 'delivery_title', 'payment_title'];
        if (required.includes(name) && (!value || value == '')) {
            return gettext("Položka %s je povinná!").replace("%s", name);
        }

        // polozky ktere mohou byt nula ale nesmi byt null
        const notNull = ['price_payment', 'price_delivery'];
        if (notNull.includes(name) && value === null) {
            return gettext("Položka %s nesmí být prázdná!").replace("%s", name);
        } else if(notNull.includes(name)) {
            // console.log("Validated prop: ", name, value);
        }

        // customer_type
        const allowed_customer_types = ['COMPANY', 'PERSONAL'];
        if (name == 'customer_type' && !allowed_customer_types.includes(value)) {
            return gettext("Neplatný typ zákazníka!");
        }

        // povinne polozky pro firmu
        if (current.customer_type == 'COMPANY') {
            if (name == 'company_name' && !value) {
                return gettext("Název firmy je povinný pro firemní zákazníky!");
                return false;
            }
            if (name == 'company_id' && !value) {
                return gettext("IČO je povinné pro firemní zákazníky!");
                return false;
            }
        }

        // souhlas s VOP
        if (name == 'terms_and_conditions_consent' && value !== true) {
            return gettext("Musíte souhlasit s obchodními podmínkami!");
            return false;
        }

        // vse OK - empty string is ok
        return "";
    };

    const clean = () => {
        store.update(current => { return emptyData });
        persist();
    };

    const isReadyForSubmit = () => {
        const data = get(store);
        const errors = [];
        for (const key in data) {
            const error_message = validateProp(key, data[key]);
            if (error_message) {
                errors.push(error_message);
             }
        }
        return errors;
    };

    const isDeliveryAvailableForPersonalPickup = () => {
        const data = get(store);
        return data.delivery_is_personal_pickup === true;
    }

    // "VEREJNE" metody - END

    // "NEVEREJNE" metody - BEGIN
    const persist = () => {
        saveToStorage(get(store));
    };
    // "NEVEREJNE" metody - END

    // vraceni vytvoreneho store
    return {
        subscribe: store.subscribe,
        setProp, setDelivery, validateProp,
        isReadyForSubmit,
        isDeliveryAvailableForPersonalPickup
    };

};
/* store - END */

// export store
const orderStore = createStore();
export default orderStore;


// isOrderReadyForSubmit
export const isOrderReadyForSubmit = derived(orderStore, () => orderStore.isReadyForSubmit().length == 0);
export const orderErrors = derived(orderStore, () => orderStore.isReadyForSubmit());

export const isDeliveryAvailableForPersonalPickup = derived(orderStore, () => {
    const delivery = orderStore.isDeliveryAvailableForPersonalPickup()
    return delivery
})

export const getCountry = derived(orderStore, () => {
    return getDeliveryCountry(get(orderStore));
})

export const isDeliveryPermittedForCountry = (deliveryCountries, currentCountry) => {

    if (deliveryCountries.startsWith("-")) {
        const excludedCountries = deliveryCountries.substring(1).split(",").map(c => c.trim());
        if (excludedCountries.includes(currentCountry)) {
            // console.log("delivery not permitted for country", currentCountry, "excluded countries", excludedCountries)
            return false;
        }
    } else {
        const includedCountries = deliveryCountries.split(",").map(c => c.trim());
        if (!includedCountries.includes(currentCountry)) {
            // console.log("delivery not permitted for country", currentCountry, "included countries", includedCountries)
            return false;
        }
    }

    return true;
}
